import type { FC, ReactNode } from "react";

import { Alert, AlertDescription } from "@recobra/ui/alert";

import { getErrorMessage } from "./api";

export const PageErrorAlert: FC<{
  error: unknown;
  className?: string;
}> = ({ error, className }) => (
  <Alert variant="destructive" className={className}>
    <AlertDescription>{getErrorMessage(error)}</AlertDescription>
  </Alert>
);

export const InlineFormError: FC<{
  message?: ReactNode | null;
  className?: string;
}> = ({ message, className }) => {
  if (!message) return null;

  return (
    <Alert variant="destructive" className={className}>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};
